<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Experts - Change Order</div>
                  <p>You can change Expert list ordering by drag and drop !</p>
                </div>
              <div class="col-md-2 offset-md-3 text-right center">
                <router-link to="/admin/experts" class="btn btn-primary" role="button">
                  back
                </router-link>
              </div>
            </div>

          <div class="table-responsive text-center">
            <table class="table table-light table-bordered table-hover">
              <draggable v-model="experts.data" @start="drag=true" @end="drag=false">
                <tr v-for="(item, index) in experts.data" :key="index">
                  <td><img :src="item.small_image" alt="expert-image" class="table-thumbnail"></td>
                  <td>{{item.name}}</td>
                  <td>{{item.interestName}}</td>
                  <td>{{item.biography.substring(0,57).concat('...')}}</td>
                  <td>
                    <span class="badge badge-success" v-if="item.active"> Active </span>
                    <span class="badge badge-danger" v-else> Inactive </span>
                  </td>
                </tr>
              </draggable>
            </table>
          </div>

          <div class="offset-md-3 col-md-6 text-center">
            <button class="btn btn-primary btn-fill btn-block" @click="updateExpertsListing">
              Update listings order
            </button>
          </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import draggable from 'vuedraggable'
    const expertColumns = ['Image', 'Name', 'Interest', 'Biography', 'Status'];
    export default {
        name: 'Experts',
        components: {
            LTable,
            draggable,
        },
        data() {
        return {
            experts: {
        data: []
    }
    }
    },
    methods: {
      updateExpertsListing () {
          let data = this.experts.data;
          let expertIds = data.map((obj) => {
            return obj.expertId
          });
          this.$store.dispatch('UPDATE_EXPERTS_ORDERING', {dispOrderExpertIds: expertIds})
            .then((res) => {
              console.log("UPDATE_EXPERTS_ORDERING API res : ", res);
              this.$swal('Success!', 'Display order updated successfully', 'success');
              this.$router.push('/admin/experts')
            })
            .catch(err => {
              console.log("UPDATE_EXPERTS_ORDERING API error : ", err);
            })
        },
        fetchExperts () {
            this.$store.dispatch('FETCH_EXPERTS')
                    .then((res) => {
                        this.experts.data = res;
                        console.log(res)
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        }
    },
    created() {
        this.fetchExperts();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Experts/OrderExperts.vue